import { loadable } from '@conekta/cronos/dynamic';
import { HeadUniversal } from 'app/pages/frames/components/HeadUniversal/HeadUniversal';

import { ConektaComponentProps } from '../../component/views/EmbeddedLoadable';

import type { FC } from 'react';

const LoadableView = loadable<ConektaComponentProps>(() => import('../../component/views/EmbeddedLoadable'), {
  ssr: false,
});

export const Main: FC = () => (
  <>
    {/* ConektaSource.TOKENIZER */}
    <HeadUniversal>
      <script src={`${process.env.BASE_URL}v1.0/js/conekta-component-tokenizer.min.js`} />
      <script src={process.env.WRAPPER_URL} />
    </HeadUniversal>
    <LoadableView isTokenizer />
  </>
);
